module.exports = __webpack_public_path__ + "img/sub-features-3 OLD.d022833.jpg";